import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from 'app/shared/services/data/data.service';
import { UserService } from 'app/shared/services/user/user.service';


@Component({
  selector: 'app-ask-licence',
  templateUrl: './ask-licence.component.html',
  styleUrls: ['./ask-licence.component.scss']
})
export class AskLicenceComponent implements OnInit {

  constructor(
    private dataService: DataService,
    private router: Router,
    private userService: UserService

  ) { }


  ngOnInit(): void {
  }

  no(): void {
    this.router.navigate(['/choice-persona']);
    this.getMenus();

  }


  nextStep(): void {
    this.dataService.linkYourAccount.next(true);
    this.getMenus();

  }

  private getMenus(): void {
    this.userService.getMenuUser().subscribe(res => {
      this.dataService.menu.next(res);
    });
  }


}
